<template>
  <PickerPopup :value="value" @input="onConfirm" :columns="columns">
    <div class="input-wrapper">
      <div class="input-label" v-if="!!label">{{label}}：</div>
      <div class="chat-input">
        <ChatInput :value="columns[value]?.label ?? placeholder" readonly>
          <template #right-icon>
            <img class="bottom-icon" src="@/assets/images/select_icon.png" alt="选择">
          </template>
        </ChatInput>
      </div>
    </div>
  </PickerPopup>
</template>
<script>
import ChatInput from "../ChatInput/index.vue";
import PickerPopup from '../../Form/PickerPopup'
export default {
  components: {
    ChatInput,
    PickerPopup
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [Number, String],
      required: true
    },
    columns: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  methods: {
    onConfirm(index) {
      this.$emit("input", index)
    }
  }
}

</script>

<style scoped lang="scss">
.input-wrapper{
  width: 100%;
  display: flex;
  align-items: center;
}
.input-label{
  font-size: 12px;
  font-weight: 500;
  line-height: 23px;
  color: rgba(59, 59, 59, 1);
  text-align: left;
  vertical-align: top;
}
.chat-input {
  flex: 1;
  .bottom-icon {
    width: 14px;
    height: 14px;
    line-height: 0;
  }
}

</style>